export default __webpack_public_path__ + "static/media/other_domain.fab66e40.svg";